import apiClient from '../middleware/apiClient';
import { INSTALLMENT_PLANS } from '../helpers/apis';
import { DEFAULT_INSTALLMENT_PLAN_DEPOSIT } from '../helpers/installmentPlans';

export const GET_INSTALLMENT_PLANS_ELIGIBILITY = 'GET_INSTALLMENT_PLANS_ELIGIBILITY';
export const GET_INSTALLMENT_PLANS_ELIGIBILITY_SUCCESS = 'GET_INSTALLMENT_PLANS_ELIGIBILITY_SUCCESS';
export const GET_INSTALLMENT_PLANS_ELIGIBILITY_FAILURE = 'GET_INSTALLMENT_PLANS_ELIGIBILITY_FAILURE';

export const getInstallmentPlansEligibility = (
  deposit = DEFAULT_INSTALLMENT_PLAN_DEPOSIT,
) => async (dispatch) => {
  try {
    // Validate and coerce deposit to a non-negative number
    const numDeposit = Number(deposit);
    const depositAmount = Number.isFinite(numDeposit)
      ? Math.max(0, numDeposit)
      : DEFAULT_INSTALLMENT_PLAN_DEPOSIT;
    const params = new URLSearchParams({ deposit: String(depositAmount) });
    const url = `${INSTALLMENT_PLANS}?${params}`;
    const response = await dispatch({
      type: GET_INSTALLMENT_PLANS_ELIGIBILITY,
      payload: apiClient.fetch(url),
    }).payload;

    dispatch({
      type: GET_INSTALLMENT_PLANS_ELIGIBILITY_SUCCESS,
      payload: response,
    });
  } catch (error) {
    dispatch({
      type: GET_INSTALLMENT_PLANS_ELIGIBILITY_FAILURE,
      payload: {
        message: error?.message,
        error: error?.error,
      },
    });
  }
};
